var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHitDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C7.66863 0 7.4 0.268629 7.4 0.6V9.37805L6.05555 7.80952C5.8399 7.55793 5.46112 7.52879 5.20953 7.74445C4.95793 7.9601 4.92879 8.33888 5.14445 8.59047L7.54445 11.3905C7.65844 11.5235 7.82484 11.6 8 11.6C8.17515 11.6 8.34156 11.5235 8.45555 11.3905L10.8556 8.59047C11.0712 8.33888 11.0421 7.9601 10.7905 7.74445C10.5389 7.52879 10.1601 7.55793 9.94445 7.80952L8.6 9.37805L8.6 0.6C8.6 0.268629 8.33137 0 8 0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 6.2V6.50262C10.3868 6.29579 11.065 6.39928 11.5714 6.83334C12.3262 7.4803 12.4136 8.61664 11.7666 9.37142L9.36663 12.1714C9.02466 12.5704 8.52543 12.8 7.99997 12.8C7.4745 12.8 6.97527 12.5704 6.63331 12.1714L4.23331 9.37143C3.58634 8.61664 3.67376 7.4803 4.42854 6.83334C4.93494 6.39928 5.61309 6.29579 6.19997 6.50262V6.2H4.8C2.53726 6.2 1.40589 6.2 0.702943 6.90294C0 7.60589 0 8.73726 0 11V11.8C0 14.0627 0 15.1941 0.702943 15.8971C1.40589 16.6 2.53726 16.6 4.79999 16.6H11.2C13.4627 16.6 14.5941 16.6 15.2971 15.8971C16 15.1941 16 14.0627 16 11.8V11C16 8.73726 16 7.60589 15.2971 6.90294C14.5941 6.2 13.4627 6.2 11.2 6.2H9.79997Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitDisable);
export default __webpack_public_path__ + "static/media/hit-disable.c4655c7d6df2d98014632d87d1d8388a.svg";
export { ForwardRef as ReactComponent };